export const WHATSAPP_NUMBER = "48512287255";
export const WHATSAPP_MSG = encodeURIComponent(
  "¡Hola EuropeJobs! Quiero información sobre las vacantes para trabajar en Europa 🇵🇱"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

export const MONTHS = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const ENGLISH_LEVELS = [
  { value: "ninguno", label: "Ninguno" },
  { value: "basico", label: "Básico" },
  { value: "intermedio", label: "Intermedio" },
  { value: "avanzado", label: "Avanzado" },
];

export const COUNTRIES = [
  { code: "+52", name: "México", flag: "🇲🇽" },
  { code: "+57", name: "Colombia", flag: "🇨🇴" },
  { code: "+51", name: "Perú", flag: "🇵🇪" },
  { code: "+593", name: "Ecuador", flag: "🇪🇨" },
  { code: "+56", name: "Chile", flag: "🇨🇱" },
  { code: "+54", name: "Argentina", flag: "🇦🇷" },
  { code: "+58", name: "Venezuela", flag: "🇻🇪" },
  { code: "+502", name: "Guatemala", flag: "🇬🇹" },
  { code: "+503", name: "El Salvador", flag: "🇸🇻" },
  { code: "+504", name: "Honduras", flag: "🇭🇳" },
  { code: "+591", name: "Bolivia", flag: "🇧🇴" },
  { code: "+595", name: "Paraguay", flag: "🇵🇾" },
  { code: "+598", name: "Uruguay", flag: "🇺🇾" },
  { code: "+506", name: "Costa Rica", flag: "🇨🇷" },
  { code: "+1", name: "Rep. Dominicana", flag: "🇩🇴" },
];

// Passport guidance per country
export const PASSPORT_GUIDES = {
  México: {
    authority: "Secretaría de Relaciones Exteriores (SRE)",
    link: "https://citas.sre.gob.mx/",
    time: "3 a 7 días hábiles",
    steps: [
      "Agenda tu cita en MiConsulado / citas.sre.gob.mx",
      "Reúne: acta de nacimiento, INE vigente y CURP",
      "Paga el derecho de pasaporte en el banco o en línea",
      "Acude a tu cita en la oficina de la SRE con tus documentos",
    ],
    cost: "Desde ~$1,600 MXN (3 años) o ~$2,300 MXN (6 años)",
  },
  Colombia: {
    authority: "Cancillería de Colombia",
    link: "https://www.cancilleria.gov.co/tramites_servicios/pasaportes",
    time: "1 a 5 días hábiles",
    steps: [
      "Agenda cita en la página de la Cancillería o Gobernación",
      "Reúne: cédula de ciudadanía vigente",
      "Paga el valor del pasaporte",
      "Acude a la cita y toma de datos biométricos",
    ],
    cost: "Consultar tarifa vigente en la Cancillería",
  },
  Perú: {
    authority: "Superintendencia Nacional de Migraciones",
    link: "https://www.gob.pe/235-obtener-el-pasaporte-electronico",
    time: "El mismo día en muchos casos",
    steps: [
      "Paga la tasa en el Banco de la Nación (págalo.pe)",
      "Reúne: DNI vigente",
      "Agenda o acude a Migraciones",
      "Toma de foto y datos biométricos",
    ],
    cost: "S/ 110.60 aprox.",
  },
  default: {
    authority: "Autoridad de pasaportes / Cancillería de tu país",
    link: "https://wa.me/48512287255",
    time: "Varía según el país (normalmente 1 a 3 semanas)",
    steps: [
      "Contáctanos por WhatsApp y te guiamos paso a paso",
      "Reúne tu documento de identidad vigente y acta de nacimiento",
      "Agenda cita en la oficina de pasaportes de tu país",
      "Nosotros te acompañamos durante todo el proceso",
    ],
    cost: "Te asesoramos gratis para sacarlo",
  },
};

export const STATUS_FLOW = [
  { value: "nuevo", label: "Nuevo", color: "#3B82F6" },
  { value: "contactado", label: "Contactado", color: "#8B5CF6" },
  { value: "confirmo_viaje", label: "Confirmó viaje", color: "#14B8A6" },
  { value: "documentos_ok", label: "Documentos OK", color: "#06B6D4" },
  { value: "esperando_pasaporte", label: "Esperando pasaporte", color: "#F59E0B" },
  { value: "aprobado", label: "Aprobado", color: "#10B981" },
  { value: "viajando", label: "Viajando", color: "#EC4899" },
  { value: "contratado", label: "Contratado", color: "#22C55E" },
];

export const statusMeta = (v) => STATUS_FLOW.find((s) => s.value === v) || STATUS_FLOW[0];
export const englishLabel = (v) => (ENGLISH_LEVELS.find((e) => e.value === v) || {}).label || v;

export const FLIGHT_OPTIONS = [
  { value: "por_definir", label: "Por definir" },
  { value: "financiado_100", label: "Financiado 100% (empresa)" },
  { value: "financiado_50", label: "Financiado al 50%" },
  { value: "pagado_trabajador", label: "Pagado por el trabajador" },
];

export const flightLabel = (v) => (FLIGHT_OPTIONS.find((f) => f.value === v) || {}).label || "Por definir";

export const NATIONALITIES = [
  "Mexicana", "Colombiana", "Peruana", "Ecuatoriana", "Chilena", "Argentina",
  "Venezolana", "Guatemalteca", "Salvadoreña", "Hondureña", "Boliviana",
  "Paraguaya", "Uruguaya", "Costarricense", "Dominicana", "Otra",
];

// --- Financiamiento del vuelo (tipo de cambio actual PLN → MXN) ---
export const PLN_TO_MXN = 4.6;
export const TRIP_COST_PLN = 8000;
const _fmt = (n) => Math.round(n).toLocaleString("es-MX");
export const toMXN = (plnValue) => "$" + _fmt(plnValue * PLN_TO_MXN) + " MXN";
export const toPLN = (v) => _fmt(v) + " PLN";

// Info dinámica que se muestra al elegir cómo pagar el vuelo en Etapa 2
export const FLIGHT_OPTIONS_INFO = {
  financiado_100: {
    title: "Financiado 100%",
    short: "La empresa paga el vuelo; se descuenta de tu sueldo en 3 pagos.",
    badge: "Sin pago por adelantado",
    lines: [
      `Costo total del viaje: ${toPLN(8000)} (≈ ${toMXN(8000)}).`,
      "No pagas nada por adelantado.",
      `Se descuenta de tu sueldo en 3 pagos mensuales de ~${toPLN(2667)} (≈ ${toMXN(2667)}) cada uno, durante los primeros 3 meses.`,
    ],
  },
  financiado_50: {
    title: "Financiado al 50%",
    short: "Pagas la mitad por adelantado y el resto se financia.",
    badge: "Pago inicial + financiado",
    lines: [
      `Costo total del viaje: ${toPLN(8000)} (≈ ${toMXN(8000)}).`,
      `Pagas por adelantado ${toPLN(4000)} (≈ ${toMXN(4000)}).`,
      `El 50% restante (${toPLN(4000)}) se descuenta de tu sueldo en 3 pagos de ~${toPLN(1333)} (≈ ${toMXN(1333)}) cada uno.`,
    ],
  },
  pagado_trabajador: {
    title: "Lo pago yo",
    short: "Pagas el total y todo lo que ganes es para ti desde el día 1.",
    badge: "Sin descuentos de sueldo",
    lines: [
      `Costo total del viaje: ${toPLN(8000)} (≈ ${toMXN(8000)}).`,
      "Pagas el total del viaje por adelantado.",
      "No se descuenta nada de tu sueldo; todo lo que ganes es para ti desde el día 1.",
    ],
  },
};
